// extracted by mini-css-extract-plugin
module.exports = {"AssignButton":"AssignInvoiceToWorkflowUser_AssignButton__3E7q9","Disabled":"AssignInvoiceToWorkflowUser_Disabled__24bKq"};